import React, { Component, Fragment } from 'react';

import UserHeadingSession from './UserHeadingSession';

class ItemInnerMenuWap extends Component {
  render() {
    const { subMenu, menuIndex, shouldShowMenu, infoSession, handleLoginWithAuth0 } = this.props;

    return (
      <Fragment>
        <div className={'aligmentItems buttonSessionContainer borderButtonSession'}>
          {
            <UserHeadingSession
              customer={infoSession}
              handleLogin={handleLoginWithAuth0}
            />
          }
        </div>
       
      </Fragment>
    );
  }
}

export default ItemInnerMenuWap;

